<template>
	<div class="d-flex a-center j-center">
		<div class="cus-content-box">
			<div style="overflow-y: scroll;height: 55rem;" class="cus-s-c">
				<div style="" class="d-flex a-center title-text-sty">
					<div style="width: 4px;height: 16px;background-color: #205DFF;margin-right: 10px;"></div>
					基本资料
				</div>
				<div class="d-flex a-center">
					<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
						<div class="left-text-sty" style="margin-bottom: 0.5rem;">客户称呼：</div>
						<input type="text" placeholder="客户称呼" class="sr-sty" v-model="cusInfo.name">
					</div>
					<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
						<div class="left-text-sty" style="margin-bottom: 0.5rem;">联系电话：</div>
						<input type="text" placeholder="联系电话" class="sr-sty" v-model="cusInfo.mobile">
					</div>
					<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
						<div class="left-text-sty" style="margin-bottom: 0.5rem;">微信：</div>
						<input type="text" placeholder="微信" class="sr-sty" v-model="cusInfo.wx_number">
					</div>
				</div>
				<div class="d-flex a-center">
					<div style="box-sizing: border-box;padding-left: 1.25rem;" class=" m-t-24">
						<div class="left-text-sty" style="margin-bottom: 0.5rem;">单位名称：</div>
						<input type="text" placeholder="单位名称" class="sr-sty" v-model="cusInfo.business_name">
					</div>
					<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
						<div class="left-text-sty" style="margin-bottom: 0.5rem;">客户来源：</div>
						<input type="text" placeholder="客户来源" class="sr-sty" v-model="cusInfo.source">
					</div>
					<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
						<div class="left-text-sty" style="margin-bottom: 0.5rem;">客户意向度：</div>
						<input type="text" placeholder="客户意向度" class="sr-sty" v-model="cusInfo.yi_xiang">
					</div>
				</div>
				<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
					<div class="left-text-sty" style="margin-bottom: 0.5rem;">客户价值：</div>
					<input type="text" placeholder="客户价值" class="sr-sty" v-model="cusInfo.cus_value">
				</div>
				<div style="" class="d-flex a-center title-text-sty m-t-24">
					<div style="width: 4px;height: 16px;background-color: #205DFF;margin-right: 10px;"></div>
					补充资料
				</div>
				<div class="d-flex a-center">
					<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
						<div class="left-text-sty" style="margin-bottom: 0.5rem;">身份证号码：</div>
						<input type="text" placeholder="身份证号码" class="sr-sty" v-model="cusInfo.id_card">
					</div>
					<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
						<div class="left-text-sty" style="margin-bottom: 0.5rem;">身份证地址：</div>
						<input type="text" placeholder="身份证地址" class="sr-sty" v-model="cusInfo.address">
					</div>
					<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
						<div class="left-text-sty" style="margin-bottom: 0.5rem;">婚姻子女情况：</div>
						<input type="text" placeholder="婚姻子女情况" class="sr-sty" v-model="cusInfo.family">
					</div>
				</div>
				<div class="d-flex a-center">
					<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
						<div class="left-text-sty" style="margin-bottom: 0.5rem;">股东身份证号码：</div>
						<input type="text" placeholder="股东身份证号码" class="sr-sty" v-model="cusInfo.gu_id_card">
					</div>
					<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
						<div class="left-text-sty" style="margin-bottom: 0.5rem;">收费标准按月付息：</div>
						<input type="text" placeholder="收费标准按月付息" class="sr-sty" v-model="cusInfo.interest">
					</div>
					<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
						<div class="left-text-sty" style="margin-bottom: 0.5rem;">赎楼房产评估价：</div>
						<input type="text" placeholder="赎楼房产评估价" class="sr-sty" v-model="cusInfo.floor_note">
					</div>
				</div>
				<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
					<div class="left-text-sty" style="margin-bottom: 0.5rem;">复批经理及电话：</div>
					<input type="text" placeholder="复批经理及电话" class="sr-sty" v-model="cusInfo.other_note">
				</div>
				<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24" v-if="cusInfo.img_a && cusInfo.img_a.length!=0">
					<div class="left-text-sty d-flex a-center j-sb" style="margin-bottom: 1.5rem;width: 37.5rem;">
						房产证照片：
						<!-- <div style="color: #205DFF;font-size:12px;font-weight: bold;cursor: pointer;">批量下载</div> -->
					</div>
					<div class="d-flex a-center flex-wrap j-sb" style="width: 220px;box-sizing: border-box;">
						<div style="width: 6.5625rem;height: 5rem;border-radius: 6px;" v-for="(item,index) in cusInfo.img_a" :key="index">
							<a :href="item" target="_blank" style="display: block;text-decoration: none;">
								<img :src="item" alt="" style="width: 6.5625rem;height: 5rem;border-radius: 0.375rem;">
							</a>
						</div>
					</div>
				</div>
				<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24" v-if="cusInfo.img_b.length!=0 || cusInfo.other_file.length!=0">
					<div class="left-text-sty d-flex a-center j-sb" style="margin-bottom: 1.5rem;width: 37.5rem;">
						征信报告照片：
						<!-- <div style="color: #205DFF;font-size:12px;font-weight: bold;cursor: pointer;">批量下载</div> -->
					</div>
					<div class="d-flex a-center" style="width: 220px;box-sizing: border-box;margin-bottom: 1.5rem;" v-if="cusInfo.img_b && cusInfo.img_b.length!=0">
						<div style="width: 3.125rem;height: 5rem;border-radius: 6px;margin-right: 0.625rem;" v-for="(item,index) in cusInfo.img_b" :key="index">
							<a :href="item" target="_blank" style="display: block;text-decoration: none;">
								<img :src="item" alt="" style="width: 3.125rem;height: 5rem;border-radius: 0.375rem;">
							</a>
						</div>
					</div>
					<div class="d-flex a-center flex-wrap" style="width: 220px;box-sizing: border-box;">
						<div style="margin-right: 0.625rem;display: flex;flex-direction: column;align-items: center;color: #000000;font-size: 0.75rem;" 
						v-for="(fitem,findex) in cusInfo.other_file" :key="findex">
							<a :href="fitem.file_url" target="_blank" style="display: block;text-decoration: none;color: #000000;">
								<template v-if="fileType(fitem.file_url)=='doc' || fileType(fitem.file_url)=='docx'">
									<img src="../../assets/spread/word.png" style="width: 2.25rem;height: 2.5rem;" alt="">
								</template>
								<template v-if="fileType(fitem.file_url)=='xls' || fileType(fitem.file_url)=='xlsx'">
									<img src="../../assets/spread/xls.png" style="width: 2.25rem;height: 2.5rem;" alt="">
								</template>
								<template v-if="fileType(fitem.file_url)=='pdf'">
									<img src="../../assets/spread/pdf.png" style="width: 2.25rem;height: 2.5rem;" alt="">
								</template>
								<div style="width: 3.625rem;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;margin-top: 0.5rem;">{{fitem.file_name}}</div>
							</a>
						</div>
					</div>
				</div>
				<div style="" class="d-flex a-center title-text-sty m-t-24">
					<div style="width: 4px;height: 16px;background-color: #205DFF;margin-right: 10px;"></div>
					备注信息
				</div>
				<div style="box-sizing: border-box;padding-left: 1.25rem;" class="d-flex m-t-24">
					<div class="left-text-sty">备注内容：</div>
					<div class="" style="width: 220px;box-sizing: border-box;color: #888888;font-size: 12px;">
						{{cusInfo.note}}
					</div>
				</div>
				<div style="" class="d-flex a-center title-text-sty m-t-24">
					<div style="width: 4px;height: 16px;background-color: #205DFF;margin-right: 10px;"></div>
					其他信息
				</div>
				<div class="d-flex a-center">
					<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24" v-if="cusInfo.other_info.add_time">
						<div class="left-text-sty" style="margin-bottom: 0.5rem;">客户创建时间：</div>
						<div class="" style="width: 220px;box-sizing: border-box;color: #888888;font-size: 12px;">
							{{cusInfo.other_info.add_time}}
						</div>
					</div>
					<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
						<div class="left-text-sty" style="margin-bottom: 0.5rem;">总联系次数：</div>
						<div class="" style="width: 220px;box-sizing: border-box;color: #888888;font-size: 12px;">
							{{cusInfo.other_info.lx_num}}次
						</div>
					</div>
					<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
						<div class="left-text-sty" style="margin-bottom: 0.5rem;">最后联系时间：</div>
						<div class="" style="width: 220px;box-sizing: border-box;color: #888888;font-size: 12px;">
							{{cusInfo.other_info.lx_last_time}}
						</div>
					</div>
				</div>
				<template v-if="cusInfo.status==1">
					<div class="d-flex a-center">
						<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
							<div class="left-text-sty" style="margin-bottom: 0.5rem;">总成交次数：</div>
							<div class="" style="width: 220px;box-sizing: border-box;color: #888888;font-size: 12px;">
								{{cusInfo.other_info.cj_num}}
							</div>
						</div>
						<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
							<div class="left-text-sty" style="margin-bottom: 0.5rem;">成交分布：</div>
							<div class="d-flex a-center j-sb" style="width: 220px;box-sizing: border-box;color: #888888;font-size: 12px;">
								<div>后台成交{{cusInfo.other_info.cj_num_b}}次</div>
								<div>自行成交{{cusInfo.other_info.cj_num_a}}次</div>
							</div>
						</div>
						<div style="box-sizing: border-box;padding-left: 1.25rem;" class="m-t-24">
							<div class="left-text-sty" style="margin-bottom: 0.5rem;">最后成交时间：</div>
							<div class="" style="width: 220px;box-sizing: border-box;color: #888888;font-size: 12px;">
								{{cusInfo.other_info.cj_last_time}}
							</div>
						</div>
					</div>
				</template>
			</div>
			<div class="d-flex a-center" style="box-sizing: border-box;padding-left: 5.625rem;position: absolute;bottom: 18px;">
				<el-button size="mini" @click="ctrl_custom(1)"
				style="background: #FFFFFF;color: #888888; width: 5rem;height: 1.5rem;line-height: 1.5rem;padding: 0;border: 1px solid #888888;box-sizing: border-box;">删除</el-button>
				<el-button size="mini" @click="ctrl_custom(0)"
				style="background: #1E69FF;color: #FFFFFF; width: 5rem;height: 1.5rem;line-height: 1.5rem;padding: 0;margin-left: 1.875rem;"
				>成交</el-button>
				<el-button size="mini" @click="saveFile"
				style="background: #1E69FF;color: #FFFFFF; width: 5rem;height: 1.5rem;line-height: 1.5rem;padding: 0;margin-left: 1.875rem;"
				>保存资料</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				custom_id:'',
				cusInfo:{}
			}
		},
		created() {
			this.custom_id = this.$route.query.custom_id
			this.admin_get_customer_info()
		},
		mounted() {
			
		},
		methods:{
			fileType(file){
				let index = file.lastIndexOf(".")
				return file.substring(index+1)
			},
			admin_get_customer_info(){
				let params={
					act: 'admin_get_customer_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					custom_id: this.custom_id,
				}
				this.$api.admin_get_customer_info(params).then((res)=>{
					if(res.code==0){
						this.cusInfo=res.data
					}
				})
			},
			ctrl_custom(type){
				this.$msgbox.confirm('是否确认此操作?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.admin_ctrl_custom(this.custom_id,type)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});  
				})
			},
			admin_ctrl_custom(custom_id,type){
				let params={
					act:'admin_ctrl_custom',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					custom_id:custom_id,
					type:type
				}
				this.$api.admin_ctrl_custom(params).then((res)=>{
					if(res.code==0){
						this.$message({
							showClose: false,
							message:type==0?'操作成交成功':'删除成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			saveFile(){
				let params={
					act:'save_custom_info',
					...this.cusInfo,
					path:1,
					is_supply:'',
				}
				this.$api.save_custom_info(params).then((res)=>{
					if(res.data.code==0){
						this.$message({
							showClose: false,
							message:'保存资料成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
		}
	}
</script>

<style scoped>
	.cus-s-c::-webkit-scrollbar{
		display: none;
	}
	.cus-content-box{
		width: 85rem;
		min-height: 60rem;
		position: relative;
		box-sizing: border-box;
		background-color: #FFFFFF;
		border-radius: 0.625rem;
		padding: 1.5rem 1.5rem 1.5rem 20rem;
	}
	.m-t-24{
		margin-top: 1rem;
	}
	.title-text-sty{
		color: #205DFF;
		font-size: 0.875rem;
		font-weight: 600;
	}
	.left-text-sty{
		color: ##404040;
		font-size: 0.75rem;
		font-weight: 600;
		width: 7.5rem;
		margin-right: 1.25rem;
		white-space: nowrap;
	}
	.sr-sty{
		color: #000000;
		font-size: 0.75rem;
		padding: 0 0.75rem;
		box-sizing: border-box;
		width: 13.75rem;
		height: 1.375rem;
		border: 1px solid #BBBBBB;
	}
	.sr-pla-sty{
		color: #888888;
		font-size: 0.75rem;
	}
</style>